/**
 * Async entry for ModuleFederationPlugin.
 */

import { clearChunkReloadFlag, handleChunkLoadError } from '#client/utils/chunkLoadError';

import('#client/directEntry').then(clearChunkReloadFlag).catch((error) => {
  if (!handleChunkLoadError(error)) {
    throw error;
  }
});
